import fetchApi from './fetch';

// ثبت‌نام کاربر
export function registerUser(account_name, password, phone_number_number) {
  return fetchApi('/user/register', 'POST', { account_name, password, phone_number_number });
}

export function loginUser(account_name, password) {
  return fetchApi('/user/login', 'POST', { account_name, password });
}